/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 购票后成长值的变化
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  ticketPurchaseGrowthValueDTO: member.TicketPurchaseGrowthValueDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/ticket-growth/update`,
    data: ticketPurchaseGrowthValueDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
